<template>
  <div class="sumber-aboutUs">
    <menuBox :step="2"></menuBox>
    <div class="sumber-aboutusbox">
      <div class="banner-text">
        <div class="bt">Berita Terbaru</div>
        <div class="title">
          Masa depan kekayaan yang baru
        </div>
        <div class="text">
          Memberikan solusi keuangan inovatif kepada nasabah untuk mendorong pertumbuhan keuangan.
        </div>
      </div>
    </div>
    <div class="bredInfo">
      <img class="leftImg" src="../assets/aboutUs1.png" alt="">
      <div>
        <div class="item">
          1. Fintech memimpin perubahan dan meningkatkan efisiensi dan kenyamanan layanan keuangan.
        </div>
        <div class="item">
          2. Popularitas perbankan digital dan pembayaran seluler telah mengubah model bisnis perbankan tradisional.
        </div>
        <div class="item">
          3. Kecerdasan buatan akan meningkatkan kemampuan keamanan dan analisis data layanan keuangan.
        </div>
        <div class="item">
          4. Blockchain akan mendorong transparansi dan keamanan dalam transaksi keuangan.
        </div>
      </div>
    </div>
    <div class="bredInfo bredInfoTwo">
      <div>
        <div class="item">
          1. Perusahaan asuransi secara bertahap bertransformasi ke digitalisasi untuk meningkatkan pengalaman nasabah.
        </div>
        <div class="item">
          2. Mengembangkan produk asuransi yang dipersonalisasi melalui big data dan AI untuk memenuhi berbagai
          kebutuhan pelanggan.
        </div>
        <div class="item">
          3. Teknologi Blockchain akan meningkatkan transparansi dan efisiensi proses klaim.
        </div>
        <div class="item">
          4. Big data dan AI memungkinkan perusahaan asuransi melakukan penilaian risiko yang lebih akurat.
        </div>
      </div>
      <img class="rightImg" src="../assets/aboutUs2.png" alt="">
    </div>
    <div class="aboutUsImg">
      <img src="../assets/aboutUs3.png" alt="">
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
  },
};
</script>
<style lang="less" scoped>
.sumber-aboutusbox {
  background-image: url(../assets/aboutUs.png);
  width: 100%;
  height: 640px;
  background-size: 100% 100%;
  overflow: hidden;

  .banner-text {
    padding: 250px 360px 0;
    box-sizing: border-box;

    .bt {
      margin-bottom: 10px;
      font-weight: 700;
      font-size: 48px;
      color: #333333;
      line-height: 68px;
    }

    .title {
      margin-bottom: 28px;
      font-size: 22px;
      color: #333333;
      line-height: 31px;
    }

    .text {
      font-size: 18px;
      color: #333333;
      line-height: 21px;
    }
  }
}

.bredInfo {
  padding: 100px 360px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .rightImg {
    margin-left: 80px;
    width: 564px;
    height: 420px;
  }

  .leftImg {
    margin-right: 80px;
    width: 564px;
    height: 420px;
  }

  .item {
    margin-bottom: 24px;
    font-size: 18px;
    color: #999999;
    line-height: 21px;
  }

  .item:last-child {
    margin-bottom: 0;
  }
}

.bredInfoTwo {
  padding-top: 20px !important;
}

.aboutUsImg {
  margin: 100px 360px;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 430px;
  }
}
</style>
